import { RATE_TYPES } from '@ratehub/documents/mtg-journey-document/stable';


const FIXED_TERM_OPTIONS = [ 2, 3, 5, 10 ];
const VARIABLE_TERM_OPTIONS = [ 3, 5 ];

/**
 *
 * @param {'fixed'|'variable'} rateType
 *
 * @returns {string[]} term options
 */
function getTermOptionsByRateType(rateType) {
    if (!rateType) {
        return [];
    }

    return rateType === RATE_TYPES.VARIABLE
        ? VARIABLE_TERM_OPTIONS
        : FIXED_TERM_OPTIONS;
}

export default getTermOptionsByRateType;
